import { Link, Box, Container, Grid, Typography } from "@mui/material";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import Carousel from "react-material-ui-carousel";

const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

const sponsors = [
  {
    id: "BattleFoam",
    name: "Battle Foam",
    url: "https://www.battlefoam.com/",
    imageUrl: "battle-foam.png",
  },
  {
    id: "WeylandYutani",
    name: "Weyland Yutani",
    url: "https://www.weyland-yutani-inc.com/?utm_source=bcp&utm_medium=bcp&utm_campaign=bcp",
    imageUrl: "weyland-yutani.png",
  },
];

export default function SponsorsBar(props) {
  const { titleProps } = props;

  return (
    <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
      <Grid container spacing={1} sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Typography variant="h4" gutterBottom {...titleProps}>
            Sponsors
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ display: { xs: "block", sm: "none" } }}>
            <Carousel
              interval={3000}
              autoPlay
              indicators={false}
              cycleNavigation
            >
              {sponsors.map((sponsor, index) => {
                return (
                  <Grid container key={sponsor.id}>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <SponsorItem sponsor={sponsor} />
                    </Grid>
                  </Grid>
                );
              })}
            </Carousel>
          </Box>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <Grid
              container
              sx={{ justifyContent: "center", alignItems: "center" }}
            >
              {sponsors.map((sponsor, index) => {
                return (
                  <Grid item key={sponsor.id}>
                    <SponsorItem sponsor={sponsor} />
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

function SponsorItem({ sponsor, imageProps }) {
  return (
    <Link href={sponsor?.url} target="_blank" underline="none">
      <img
        src={`${SYSTEM_IMAGES_CLOUDFRONT}/images/sponsors/${sponsor?.imageUrl}`}
        alt={sponsor?.name}
        style={{
          height: "100px",
          // maxWidth: "100%",
          // marginRight: "8px",
        }}
        {...imageProps}
      />
    </Link>
  );
}
